<template>
  <footer class="bg-blue-900 ">
  <!-- <div class="grid grid-cols-3 gap-4 justify-start pt-24 mx-40 text-white"> -->
    <div>
      <div class="container mx-auto px-6 pt-10 pb-6">
        <div class="row">
          <div class="col-12 text-center text-white">
            Copyright © 2022 365 WareHouses, Inc.      |
            <router-link to="/signin"
            class="ml-8 font-medium no-underline text-white hover:text-gray-500 focus:outline-none focus:text-gray-900 transition duration-150 ease-in-out"
          >Signin</router-link>
          </div>
        </div>
  </div>
  </div>
  <!-- </div> -->
</footer>     
</template>

<script>
    export default {
        
    }
</script>
